import { Outlet } from "react-router-dom";
import AppHeader from "./AppHeader";
import ErrorBoundary from "./errors/ErrorBoundary";

const Layout = () => {
  return (
    <>
      <AppHeader />
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </>
  );
};

export default Layout;
